/** Prompt templates — context builders for the commercial AI (no network). */

export function quoteAnalysisPrompt(payload: unknown): string {
  return [
    'Analise o orçamento comercial a seguir.',
    'Foque em margem, lucro, estoque e variação de preço.',
    'Retorne apenas recomendações com motivo. Não altere o orçamento.',
    JSON.stringify(payload),
  ].join('\n')
}

export function purchaseAnalysisPrompt(payload: unknown): string {
  return [
    'Analise a cesta de compra multi-fornecedor.',
    'Identifique consolidação, frete e risco de prazo.',
    JSON.stringify(payload),
  ].join('\n')
}

export function supplierPrompt(payload: unknown): string {
  return [
    'Recomende o melhor fornecedor com base em preço, prazo e confiabilidade.',
    'Informe o motivo da sugestão.',
    JSON.stringify(payload),
  ].join('\n')
}

export function pricingPrompt(payload: unknown): string {
  return [
    'Sugira preço ideal, margem ideal e desconto máximo.',
    'Toda sugestão deve ter motivo explícito.',
    JSON.stringify(payload),
  ].join('\n')
}

export function descriptionPrompt(payload: unknown): string {
  return [
    'Gere descrição técnica, diagnóstico, solução e observações a partir do orçamento.',
    JSON.stringify(payload),
  ].join('\n')
}

export function observationsPrompt(payload: unknown): string {
  return [
    'Gere observações comerciais: prazo, garantia, condições e validade.',
    JSON.stringify(payload),
  ].join('\n')
}

export function insightsPrompt(payload: unknown): string {
  return [
    'Gere alertas, oportunidades, riscos e resumo executivo.',
    JSON.stringify(payload),
  ].join('\n')
}

export function summarizePrompt(payload: unknown): string {
  return ['Resuma de forma executiva e objetiva.', JSON.stringify(payload)].join('\n')
}
